// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".content-container {\n    display: flex;\n    flex: 1 1;\n}\n\n.content-container aside {\n    min-width: 15%;\n}\n", "",{"version":3,"sources":["webpack://src/components/PageFormat/style.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,SAAO;AACX;;AAEA;IACI,cAAc;AAClB","sourcesContent":[".content-container {\n    display: flex;\n    flex: 1;\n}\n\n.content-container aside {\n    min-width: 15%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
